<div class="gap-xl grid">
  @if (peutModifier()) {
    <div>
      <button (click)="ajouterCaracteristique()" hlmBtn>
        Ajouter une caractéristique
        <ng-icon name="lucidePlus" />
      </button>
    </div>
  }

  <div class="gap-xs grid">
    <app-expansion-panel [actions]="peutModifier() ? secteursActiviteAction : []" titre="Secteurs d'activité">
      <div class="grid">
        @for (secteur of secteur()?.sousCaracteristiques | trierPar: 'nom'; track secteur.id; let last = $last) {
          <div
            class="p-xs group/item hover:bg-components-background-neutral-lighter flex h-[48px] items-center justify-between hover:rounded-b-md"
          >
            <span class="px-lg component-medium-medium">
              {{ secteur.nom }}
            </span>
            @if (peutModifier()) {
              <button
                class="invisible group-hover/item:visible"
                [hlmDropdownMenuTrigger]="actionsSecteurMenu"
                [hlmDropdownMenuTriggerData]="{ $implicit: { item: secteur } }"
                (click)="$event.stopPropagation()"
                hlmBtn
                variant="ghost"
                size="icon"
              >
                <ng-icon name="lucideEllipsisVertical" />
              </button>
            }
          </div>
          @if (!last) {
            <div hlmItemSeparator></div>
          }
        } @empty {
          <div class="pl-md pr-xs py-xs">
            <span class="paragraph-medium-medium text-content-secondary">Aucun secteur créé.</span>
          </div>
        }
      </div>
    </app-expansion-panel>
    @if (peutModifier()) {
      <app-button-add-new (click)="ajouterSecteur()" label="Ajouter un secteur d'activité" />
    }
  </div>

  @for (caracteristique of caracteristiques() | trierPar: 'nom'; track caracteristique.id) {
    <div class="gap-xs grid">
      <app-expansion-panel
        [actions]="peutModifier() ? caracteristiquesAction : []"
        [titre]="caracteristique.nom"
        [item]="caracteristique"
      >
        <div class="grid">
          @for (
            sousCaracteristique of caracteristique.sousCaracteristiques | trierPar: 'nom';
            track sousCaracteristique.id;
            let last = $last
          ) {
            <div
              class="p-xs group/item hover:bg-components-background-neutral-lighter flex h-[48px] items-center justify-between hover:rounded-b-md"
            >
              <span class="px-lg component-medium-medium">
                {{ sousCaracteristique.nom }}
              </span>
              @if (peutModifier()) {
                <button
                  class="invisible group-hover/item:visible"
                  [hlmDropdownMenuTrigger]="actionsSousCaracteristiqueMenu"
                  [hlmDropdownMenuTriggerData]="{ $implicit: { item: sousCaracteristique } }"
                  (click)="$event.stopPropagation()"
                  hlmBtn
                  variant="ghost"
                  size="icon"
                >
                  <ng-icon name="lucideEllipsisVertical" />
                </button>
              }
            </div>
            @if (!last) {
              <div hlmItemSeparator></div>
            }
          } @empty {
            <div class="pl-md pr-xs py-xs">
              <span class="paragraph-medium-medium text-content-secondary"
                >Aucune sous-caractéristique liée à cette caractéristique.</span
              >
            </div>
          }
        </div>
      </app-expansion-panel>
      @if (peutModifier()) {
        <app-button-add-new
          (click)="ajouterSousCaracteristique(caracteristique)"
          label="Ajouter une sous-caractéristique"
        />
      }
    </div>
  }
</div>

<ng-template #actionsSecteurMenu let-ctx>
  <hlm-dropdown-menu>
    @for (action of secteurAction; track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" hlmMenuIcon />
        {{ action.label }}
        @if (action.shortcut) {
          <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
        }
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>

<ng-template #actionsSousCaracteristiqueMenu let-ctx>
  <hlm-dropdown-menu>
    @for (action of sousCaracteristiqueAction; track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" hlmMenuIcon />
        {{ action.label }}
        @if (action.shortcut) {
          <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
        }
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
